export default __webpack_public_path__ + "images/8a809ad8498577a7c49d7012e6eb0609-tour_1_dont.svg";